import script from "./CallToAction2575Layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallToAction2575Layout.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__